import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_8 = { style: {"margin":"0 10px"} }
const _hoisted_9 = { style: {"white-space":"pre-wrap","max-height":"150px","overflow-y":"auto"} }

import { ref, onMounted, h } from "vue";
import { getCallable } from "@/config/env";
import {
    NDataTable,
    NSpace,
    NCheckbox,
    NCard,
    NSelect,
    NButton,
    NIcon,
    NModal,
    NRadio,
    NRadioGroup,
    NInput,
    FormInst,
    FormRules,
    useMessage,
    useNotification,
    NDescriptions,
    NDescriptionsItem,
    NTag,
    useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import * as common from "@/assets/common/common";
import { OrgMyreg } from "@/model/myreg"; // Myreg 모델 임포트
import { QueryInfo } from "@/model/common"; // QueryInfo 임포트
import { usePagination } from "@/composables/usePagination"; // usePagination 임포트
import { useAuth } from "@/composables/useAuth";

export default /*@__PURE__*/_defineComponent({
  __name: 'OrgMyreg',
  setup(__props) {

const { loading, isLoggedIn } = useAuth();

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const getOrgMyregsCallable = getCallable("getOrgMyregs"); // getMyregs 함수 호출

const componentKey = ref(0); // To force re-render if needed
const selectedItem = ref<OrgMyreg | null>(null); // 선택된 항목 (수정/등록용)

const deleteConfirmMessage = ref<string | null>(null);
const contentMessage = ref<string | null>(null);
const alertMessage = ref<string | null>(null);
const alertType = ref<string | null>(null);
const isDeleteConfirm = ref<boolean>(false);
const deleteConfirmType = ref<string | null>(null);
const isShowContent = ref<boolean>(false);
const isAlert = ref<boolean>(false);

const isDetailModalVisible = ref<boolean>(false);
const selectedOrgMyregDetail = ref<OrgMyreg | null>(null);

const {
    paginatedItems: orgMyregList,
    listLoading,
    error,
    currentPage,
    hasNextPage,
    goToNextPage: composableGoToNextPage,
    goToPreviousPage: composableGoToPreviousPage,
    refreshData: composableRefreshOrgMyregs,
} = usePagination<OrgMyreg>(
    async (params) => getOrgMyregsCallable(params),
    25 // 페이지 크기
);

async function wrappedRefreshOrgMyregs() {
    loading.value = true; // 전역 로딩 시작
    await composableRefreshOrgMyregs();
    loading.value = false; // 전역 로딩 종료
}

const columns = [
    {
        title: "index",
        resizable: true,
        render(_row: OrgMyreg, rowIndex: number) {
            return rowIndex + 1;
        },
    },
    {
        title: "기관명",
        key: "orgName",
        resizable: true,
    },
    {
        title: "담당부서",
        key: "deptName",
        resizable: true,
    },
    {
        title: "담당자 이름",
        key: "name",
        resizable: true,
    },
    {
        title: "연락처",
        key: "phoneNumber",
        resizable: true,
    },
    {
        title: "인원수",
        key: "examineeCount",
        resizable: true,
    },
    {
        title: "이메일",
        key: "email",
        resizable: true,
    },
    {
        title: "등록일",
        key: "createdDate",
        render(row: OrgMyreg) {
            return common.getDate(row.createdDate);
        },
    },
    {
        title: "상세보기",
        key: "actions",
        render(row: OrgMyreg) {
            return h(
                NButton,
                {
                    size: "small",
                    onClick: () => openDetailModal(row),
                },
                { default: () => "상세보기" }
            );
        },
    },
];

function onShowContent(row: OrgMyreg) {
    isShowContent.value = true;
    contentMessage.value = row.content;
}
function onPositiveClick() {
    isAlert.value = false;
}

function openDetailModal(item: OrgMyreg) {
    selectedOrgMyregDetail.value = item;
    isDetailModalVisible.value = true;
}

async function wrappedGoToNextPage() {
    if (hasNextPage.value) {
        await composableGoToNextPage();
    }
}

async function wrappedGoToPreviousPage() {
    if (currentPage.value > 1) {
        await composableGoToPreviousPage();
    }
}

onMounted(() => {
    wrappedRefreshOrgMyregs(); // onMounted 시 데이터 로드
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "기관 문의 관리", -1)
                ])),
                _: 1
              }),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createElementVNode("div", null, [
                (_unref(listLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "기관 문의 목록을 불러오는 중..."))
                  : _createCommentVNode("", true),
                (_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                  : _createCommentVNode("", true),
                (!_unref(listLoading) && !_unref(error))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_unref(orgMyregList).length > 0)
                          ? (_openBlock(), _createBlock(_unref(NDataTable), {
                              key: 0,
                              columns: columns,
                              data: _unref(orgMyregList),
                              pagination: false,
                              bordered: true
                            }, null, 8, ["data"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_6, "등록된 기관 문의가 없습니다."))
                      ]),
                      (_unref(orgMyregList).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToPreviousPage,
                              disabled: _unref(currentPage) === 1,
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode(" 이전 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"]),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                            _createVNode(_unref(NButton), {
                              onClick: wrappedGoToNextPage,
                              disabled: !_unref(hasNextPage)
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode(" 다음 페이지 ")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: isAlert.value,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isAlert).value = $event)),
            "mask-closable": false,
            content: alertMessage.value,
            type: alertType.value,
            preset: "dialog",
            title: "Dialog",
            "positive-text": "확인",
            onPositiveClick: onPositiveClick
          }, null, 8, ["show", "content", "type"]),
          _createVNode(_unref(NModal), {
            show: isShowContent.value,
            "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((isShowContent).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NCard), {
                style: {"width":"600px"},
                title: "내용",
                bordered: false,
                size: "huge",
                role: "dialog",
                "aria-modal": "true"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(contentMessage.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(NModal), {
            show: isDeleteConfirm.value,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isDeleteConfirm).value = $event)),
            "mask-closable": false,
            content: deleteConfirmMessage.value,
            type: deleteConfirmType.value,
            preset: "dialog",
            "negative-text": "취소",
            "positive-text": "확인",
            onPositiveClick: _ctx.onDeletePositiveClick,
            onNegativeClick: _ctx.onDeleteNegativeClick
          }, null, 8, ["show", "content", "type", "onPositiveClick", "onNegativeClick"]),
          _createVNode(_unref(NModal), {
            show: isDetailModalVisible.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((isDetailModalVisible).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NCard), {
                style: {"width":"700px","max-height":"60vh","overflow-y":"auto"},
                title: "기관 문의 상세 정보",
                bordered: false,
                size: "huge",
                role: "dialog",
                "aria-modal": "true"
              }, {
                footer: _withCtx(() => [
                  _createVNode(_unref(NButton), {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (isDetailModalVisible.value = false))
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("닫기")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (selectedOrgMyregDetail.value)
                    ? (_openBlock(), _createBlock(_unref(NDescriptions), {
                        key: 0,
                        "label-placement": "left",
                        bordered: "",
                        column: 1,
                        "label-style": { width: '200px;' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NDescriptionsItem), { label: "기관명" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.orgName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "담당부서" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.deptName || "N/A"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "담당자 이름" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.name), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "이메일" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.email), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "연락처" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.phoneNumber || "N/A"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "우편번호" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.address?.postCode || "N/A"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "주소" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.address?.address || "N/A"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "상세주소" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.address?.addressDetail || "N/A"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), {
                            style: {"white-space":"pre-wrap"},
                            label: "문의대상"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.targetProduct || "N/A"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "인원수" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedOrgMyregDetail.value.examineeCount), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "내용" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(selectedOrgMyregDetail.value.content || "N/A"), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NDescriptionsItem), { label: "등록일" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(common.getDate(selectedOrgMyregDetail.value.createdDate)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})